var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 19.658V16.658C3.9915 16.4413 0.666504 12.9747 0.666504 8.74967C0.666504 4.38301 4.2165 0.833008 8.58317 0.833008C12.9498 0.833008 16.4998 4.38301 16.4998 8.74967C16.4998 12.8747 13.6332 17.0247 9.35817 19.083L8.1665 19.658ZM8.58317 2.49967C5.13317 2.49967 2.33317 5.29967 2.33317 8.74967C2.33317 12.1997 5.13317 14.9997 8.58317 14.9997H9.83317V16.9163C12.8665 14.9997 14.8332 11.8497 14.8332 8.74967C14.8332 5.29967 12.0332 2.49967 8.58317 2.49967ZM7.74984 12.083H9.4165V13.7497H7.74984V12.083ZM9.4165 10.833H7.74984C7.74984 8.12467 10.2498 8.33301 10.2498 6.66634C10.2498 5.74967 9.49984 4.99967 8.58317 4.99967C7.6665 4.99967 6.9165 5.74967 6.9165 6.66634H5.24984C5.24984 4.82467 6.7415 3.33301 8.58317 3.33301C10.4248 3.33301 11.9165 4.82467 11.9165 6.66634C11.9165 8.74967 9.4165 8.95801 9.4165 10.833Z",
    fill: "#1D1B20",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.8c2bcb6def0e8f0c970b037c52578411.svg";
export { ForwardRef as ReactComponent };